import { computed, h, defineComponent, ref } from 'vue';
import { Modal, modalProps, ModalProps } from '@/ui/components/Modal';
import { Button } from '@/ui/components/Button';
import { pageSubtitle } from '@/ui/components';
import { t } from '@/ui/i18n/i18n';
import { inputField } from '@/ui/components/form';
import { email, ValidationErrors } from '@/entities/validation';

export const InviteByEmailModal = defineComponent<ModalProps>({
  name: 'InviteByEmailModal',
  props: modalProps,
  setup(props, context) {
    const emailValue = ref('');
    const closeModal = () => {
      context.emit('close');
      emailValue.value = '';
    };

    const inputName = 'email-value';

    const inputValidationErrors = computed<ValidationErrors>(() => {
      return emailValue.value ? email(emailValue.value, inputName) : [];
    });

    const inputNotEmptyAndValid = computed(
      () => inputValidationErrors.value.length !== 0 || emailValue.value.length === 0,
    );

    return function render() {
      const modalContent = () => [
        pageSubtitle(t('issues.invite-by-email-modal.title')),
        h('div', t('issues.invite-by-email-modal.subtitle')),
        h('div', { class: 'issue-invite-by-email-modal__input-row' }, [
          inputField({
            name: inputName,
            label: t('common.email'),
            required: true,
            placeholder: t('form.enter-email'),
            disabled: false,
            errors: inputValidationErrors.value,
            value: emailValue.value,
          }, v => {
            emailValue.value = v;
          }),
        ]),
      ];

      return h(Modal, {
        props: {
          ...props,
          customClass: 'issue-invite-by-email-modal',
          ariaRole: 'dialog',
          trapFocus: true,
          destroyOnHide: false,
          ariaModal: true,
          canCancel: ['x'],
        },
        scopedSlots: {
          actions: () => h('div', [
            h(Button, {
              props: { type: 'is-text', btnClass: 'mr-2 has-text-weight-semibold' },
              on: { click: closeModal },
            }, t('modal.cancel')),
            h(Button, {
              props: {
                disabled: inputNotEmptyAndValid.value,
              },
              on: {
                click: () => {
                  context.emit('issue-invited-by-email', emailValue.value);
                  closeModal();
                },
              },
            }, t('common.assign')),
          ]),
        },
        on: {
          close: closeModal,
        },
      }, modalContent());
    };
  },
});
